/* Scoped progressive enhancement: native details remain usable without JavaScript. */
if (!customElements.get('luxotic-faq')) {
  customElements.define('luxotic-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = [...this.querySelectorAll('button[data-category]')];
      this.groups = [...this.querySelectorAll('.faq-section')];
      this.search = this.querySelector('input[type="search"]');
      this.empty = this.querySelector('.empty-state');
      this.status = this.querySelector('[data-result-status]');
      this.querySelector('.search-wrap').hidden = false;
      this.querySelector('.category-shell').hidden = false;
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.search.value = '';
        this.selectCategory(button.dataset.category);
      }, options));
      this.search.addEventListener('input', () => this.filter(), options);
      // Theme editor block selection must reveal questions even in a hidden category.
      this.addEventListener('shopify:block:select', event => {
        const group = event.target.closest('.faq-section');
        if (!group) return;
        this.search.value = '';
        this.selectCategory(group.dataset.category);
        const item = event.target.closest('details');
        if (item) item.open = true;
      }, options);
      this.selectCategory(this.buttons[0]?.dataset.category);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    selectCategory(category) {
      this.buttons.forEach(button => {
        const active = button.dataset.category === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      this.groups.forEach(group => {
        group.hidden = group.dataset.category !== category;
        group.querySelectorAll('details').forEach(item => { item.hidden = false; });
      });
      this.empty.hidden = true;
      this.status.textContent = '';
    }

    filter() {
      const query = this.search.value.trim().toLocaleLowerCase();
      if (!query) {
        this.selectCategory(this.buttons[0]?.dataset.category);
        return;
      }
      let count = 0;
      this.buttons.forEach(button => {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
      this.groups.forEach(group => {
        let matches = 0;
        group.querySelectorAll('details').forEach(item => {
          item.hidden = !item.textContent.toLocaleLowerCase().includes(query);
          if (!item.hidden) matches++;
        });
        group.hidden = matches === 0;
        count += matches;
      });
      this.empty.hidden = count !== 0;
      this.status.textContent = `${count} matching question${count === 1 ? '' : 's'}.`;
    }
  });
}
